import {useEffect, useState} from 'react';

import languageService from '../services/localization/languageService';
import {getLocalizedLanguage} from '../services/localization/localizationService';

const useDirection = () => {
    const [isRtl, setIsRtl] = useState(false);
    const currentLocalizedCode = getLocalizedLanguage();

    useEffect(() => {
        const language = languageService.getLanguageByLanguageCode(currentLocalizedCode);

        setIsRtl(language?.isRtl);
    }, [currentLocalizedCode]);

    return isRtl ? 'rtl' : 'ltr';
};

export default useDirection;
